<template>
  <Head title="Admin - Insights Page Builder" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <report-builder 
            :report_page="report_page" 
            :metrics_filters="metrics_filters"  
            :charts="charts"  
            :group_names="group_names" 
            :data_set_types="data_set_types" 
            :integrations="integrations"
            :clients="clients"
          ></report-builder>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  report_page: Object,
  metrics_filters: Array,
  charts: Array,
  group_names: Array,
  data_set_types: Array,
  integrations: Array,
  clients: Array
});
</script>

